export default __webpack_public_path__ + "static/media/article6.25fb1776.png";